<footer class="main-footer">
  <div class="container-dynamic d-flex">
    All rights reserved
  </div>
</footer>
